import React, { useCallback, useEffect, useState } from 'react'

import ModalBase from 'components/Luxkit/Modal/ModalBase'

import EnterCode from './EnterCode'
import Success from './Success'
import { RedeemedCard } from './common'
import config from 'constants/config'
import noop from 'lib/function/noop'

interface Props {
  checkoutCurrency?: string
  onRedeem?: () => void
}

function RedeemGiftCard({ checkoutCurrency, onRedeem: onRedeemProp = noop }: Props) {
  const [currentStep, setCurrentStep] = useState<'enterCode' | 'success'>('enterCode')
  const [redeemedCards, setRedeemedCards] = useState<Array<RedeemedCard>>([])
  const [hasCamera, setHasCamera] = useState(false)

  useEffect(() => {
    navigator.mediaDevices?.enumerateDevices()
      .then(devices => {
        if (devices.some(device => device.kind === 'videoinput')) {
          setHasCamera(true)
        }
      })
      .catch(() => {
        setHasCamera(false)
      })
  }, [])

  const onRedeem = useCallback((redeemedCard: RedeemedCard) => {
    setRedeemedCards((prevRedeemedCards) => [...prevRedeemedCards, redeemedCard])
    setCurrentStep('success')
    onRedeemProp()
  }, [onRedeemProp])

  const moveToSummary = useCallback(() => {
    setCurrentStep('success')
  }, [])

  return (
    <ModalBase height="full" tabletHeight="auto">
      {currentStep === 'enterCode' && (
        <EnterCode
          onRedeem={onRedeem}
          onBack={redeemedCards.length ? moveToSummary : undefined}
          enableScan={hasCamera && config.GIFT_CARD_SCAN_ENABLED}
        />
      )}
      {currentStep === 'success' && (
        <Success
          redeemedCards={redeemedCards}
          onRedeemAnother={() => setCurrentStep('enterCode')}
          checkoutCurrency={checkoutCurrency}
        />
      )}
    </ModalBase>
  )
}

export default RedeemGiftCard
